import { AxiosGet, AxiosPost } from "../AxiosWrapper";
import { DOCUMENTSEARCH_SERVICE_URL } from "../../constants/ServiceUrls";

export const digitalSearch = (digitalSearchParameters) => {
  return AxiosPost(
    `${DOCUMENTSEARCH_SERVICE_URL}api/DocumentSearch/DigitalSearch`,
    digitalSearchParameters
  );
};

export const getMetadataFilterCollectionForDocumentTypes = (
  documentTypeIds
) => {
  return AxiosPost(
    `${DOCUMENTSEARCH_SERVICE_URL}api/DocumentSearch/GetMetadataFilterCollectionForDocumentTypes`,
    { documentTypeIds }
  );
};

export const getPhysicalSearchFilters = (searchText) => {
  return AxiosPost(
    `${DOCUMENTSEARCH_SERVICE_URL}api/DocumentSearch/GetPhysicalSearchFilters`,
    {
      searchText,
    }
  );
};

export const physicalSearch = (searchParams) => {
  return AxiosPost(
    `${DOCUMENTSEARCH_SERVICE_URL}api/DocumentSearch/PhysicalSearch`,
    { searchParams }
  );
};

export const getDigitalSearchSortingVariables = (documentTypeIds) => {
  return AxiosPost(
    `${DOCUMENTSEARCH_SERVICE_URL}api/DocumentSearch/GetDigitalSearchSortingVariables`,
    { documentTypeIds }
  );
};

export const getMetadataKeysSortedInDefaultPriority = () => {
  return AxiosGet(
    `${DOCUMENTSEARCH_SERVICE_URL}api/DocumentSearch/GetMetadataKeysSortedInDefaultPriority`
  );
};

export default {
  digitalSearch,
  getMetadataFilterCollectionForDocumentTypes,
  getPhysicalSearchFilters,
  physicalSearch,
  getDigitalSearchSortingVariables,
  getMetadataKeysSortedInDefaultPriority,
};
